import star2 from '../../images/star-2.png'

const Star2 = ({className}) => {
  return (
    <section className={className}>
        <img src={star2} alt='/' />
    </section>
  )
}

export default Star2;